export var Unicode;
(function (Unicode) {
    Unicode["NoBreakSpace"] = "\u00A0";
    Unicode["NextLine"] = "\n";
})(Unicode || (Unicode = {}));
